export default "__VITE_ASSET__vmsxEuDi__"